export default __webpack_public_path__ + "static/media/folder-open-icon.0e3fad0c.svg";